<app-filter-panel [quickSearchFilter]="filters.title" quickSearchPlaceholder="Nombre" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 cola-4">
    <span class="w-full input-field p-input-icon-right">
        <input pInputText placeholder="Nombre" [(ngModel)]="filters.title.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.title.value" class="pi pi-times cursor-pointer"
            (click)="filters.title.value = null; search()"></i>
    </span>
</div>
-->

<p-table #grid [value]="roles" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
    [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th pSortableColumn="title">Nombre <p-sortIcon field="title"></p-sortIcon></th>
            <th width="100"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-role let-columns="columns">
        <tr (dblclick)="edit(role)">
            <td>{{role.title}}</td>
            <td>
                <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowDelete" (click)="delete(role)" [rounded]="true" [text]="false"
                        severity="danger"><i class="pi pi-trash"></i></p-button>
                    <p-button *ngIf="allowWrite" (click)="edit(role)" [rounded]="true" [text]="false"><i
                            class="pi pi-pencil"></i></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>